import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { track } from '../analytics';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';

export default function BillingCallback({ type }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (type === 'fail') {
      const msg = searchParams.get('message') || '카드 등록에 실패했습니다.';
      setErrorMsg(msg);
      setStatus('error');
      track("subscription_failed", { reason: msg, stage: "billing_register" });
      return;
    }

    const authKey = searchParams.get('authKey');
    const customerKey = searchParams.get('customerKey');

    if (!authKey || !customerKey) {
      setErrorMsg('잘못된 접근입니다.');
      setStatus('error');
      return;
    }

    // customerKey에서 userId 추출 (Flask에서 uuid5로 생성했으므로 그대로 전달)
    const storedUserId = sessionStorage.getItem('findish_billing_uid');

    fetch(`${API_BASE}/billing/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ authKey, customerKey, userId: storedUserId || customerKey }),
    })
      .then(r => r.json())
      .then(data => {
        if (data.ok) {
          setStatus('success');
          track("subscription_active", { stage: "billing_registered" });
          setTimeout(() => navigate('/'), 2500);
        } else {
          setErrorMsg(data.error || '등록 실패');
          setStatus('error');
          track("subscription_failed", { reason: data.error || 'register failed', stage: "billing_register" });
        }
      })
      .catch(() => {
        setErrorMsg('네트워크 오류가 발생했습니다.');
        setStatus('error');
        track("subscription_failed", { reason: 'network error', stage: "billing_register" });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#111', color: '#f0f0f0', flexDirection: 'column', gap: 16,
    }}>
      {status === 'loading' && (
        <>
          <div style={{ fontSize: 40 }}>⏳</div>
          <p style={{ fontSize: 16 }}>카드 등록 처리 중...</p>
        </>
      )}
      {status === 'success' && (
        <>
          <div style={{ fontSize: 40 }}>✅</div>
          <h2 style={{ margin: 0 }}>구독 시작!</h2>
          <p style={{ margin: 0, opacity: 0.7 }}>7일 무료체험이 시작되었습니다. 잠시 후 이동합니다.</p>
        </>
      )}
      {status === 'error' && (
        <>
          <div style={{ fontSize: 40 }}>❌</div>
          <p style={{ color: '#e53e3e', margin: 0 }}>{errorMsg}</p>
          <button
            onClick={() => navigate('/')}
            style={{ padding: '12px 24px', borderRadius: 8, border: 'none', background: '#3182f6', color: '#fff', cursor: 'pointer', fontSize: 14 }}
          >
            홈으로 돌아가기
          </button>
        </>
      )}
    </div>
  );
}
